import React from "react"
import PropTypes from "prop-types"
import * as ItemTypes from "../../redux/items/types"

import { DckActionCreators, DckSelectors } from "dck-redux"
import { connect } from "react-redux"
import RepaymentForm from "./RepaymentForm"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { glAccountsDataWithId, sortGLAccounts } from "../../lib/utils"
import processTypes from "../../redux/processes/types"
import { loadLoanDetails } from "../../redux/actions/loans"

class Repayment extends React.Component {

  state = {
    success: false,
    error: null,
    isRunning: false,
    successText: null,
    accountType: null,
  }

  componentDidMount() {

    const { params: { id }, setCurrentLoanId, reloadLoan, loadGlAccounts,
      doLoadLoanDetails } = this.props

    setCurrentLoanId(id)
    reloadLoan(id)
    this.fecthRepaymentAccountType()
    loadGlAccounts()
    doLoadLoanDetails(id)
  }

  fecthRepaymentAccountType = () => blockingFetchService(
    accessToken => apiServerApi.getRepaymentAccountType(accessToken),
    accountType => this.setState({ accountType }),
    error => this.setState({ error: error.text }),
    _ => {}
  )

  saveRepayment = (loanId, data) => {

    this.setState({
      isRunning: true,
      error: null,
      success: null,
      successText: null
    })

    blockingFetchService(
      accessToken => apiServerApi.makeRepayment(accessToken, loanId, data), 
      response => {
        this.setState({ success: true, successText: response })
        this.props.doLoadLoanDetails(loanId)
      },
      error => this.setState({ error: error.text }),
      () => this.setState({ isRunning: false })
    )
  }

  startNewRepayment = () => this.setState({ success: false })

  render() {

    const { currentLoan, glAccountsData, loanDetails, loadDetailsRunning, loadDetailsFailed,
      doLoadLoanDetails } = this.props,
    { error, success, isRunning, successText, accountType } = this.state,

    fglAccountsData = glAccountsData.filter(({ type }) => accountType === type)

    return currentLoan ?
      <RepaymentForm
        loan={ currentLoan }
        saveRepayment={ this.saveRepayment }
        newRepayment={ this.startNewRepayment }
        error={ error }
        success={ success }
        running={ isRunning }
        successText={ successText }
        glAccountsData={ fglAccountsData }
        loanDetails={ loanDetails }
        loadDetailsRunning={ loadDetailsRunning }
        loadDetailsFailed={ loadDetailsFailed }
        reloadLoanDetails={() => doLoadLoanDetails(currentLoan.id)}
        accountType={ accountType }
      />
    : <p>Loading details ..</p>
  }
}

Repayment.propTypes = {
  currentLoan: PropTypes.object,
  setCurrentLoanId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
}

const mapStateToProps = (state, { params: { id: loanId }}) => {

  const pagedLoans = DckSelectors.selectAllItems(state, ItemTypes.Loan),

  currentLoan = pagedLoans.content
    ? pagedLoans.content.find(item => item.id === loanId)
    : undefined,

  glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)

  const glAccountsData = glAccountsDataWithId(glAccounts),

  loadDetailsRunning = DckSelectors.selectProcessRunning(
    state,
    processTypes.LOAD_LOAN_DETAILS_PROCESS
  ),

  loadDetailsFailed = DckSelectors.selectProcessFailed(
    state,
    processTypes.LOAD_LOAN_DETAILS_PROCESS
  )

  let loanDetails = DckSelectors.selectItemById(state, ItemTypes.LoanDetails, loanId)
  loanDetails = loanDetails ? loanDetails.data : null

  return { currentLoan, glAccountsData, loanDetails, loadDetailsRunning, loadDetailsFailed }
},

mapDispatchToProps = dispatch => ({

  setCurrentLoanId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Loan, id)),

  reloadLoan: id => dispatch(DckActionCreators.itemReload(ItemTypes.Loan, id)),

  loadGlAccounts: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),

  doLoadLoanDetails: loanId => dispatch(loadLoanDetails(loanId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Repayment)



// WEBPACK FOOTER //
// ./src/components/Loans/Repayment.js